import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledMember, StyledPanel, StyledItem } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import { Spinner } from 'react-bootstrap';

const ActivityDetail = (props) => {
  const { activityId } = useParams(); // 獲取 activityId 參數
  const [activity, setActivity] = useState(null);

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/activity/${activityId}`);
        if (response.data.isSuccess) {
          setActivity(response.data.result);
        }
      } catch (error) {
        console.error('Error fetching activity:', error);
      }
    };

    fetchActivity();
  }, [activityId]);

  
  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel className='content-panel'>
                { !activity
                  ? 
                    <div className='on-loading'>
                      <Spinner animation="border" role="status" variant="primary" >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  :
                    <section className='section'>
                      <div className="hgroup mb-4">
                        <h1 className="subject mb-2">{activity.subject}</h1>
                        <p>{new Date(activity.publishDate).toLocaleDateString()}</p>
                      </div>
                      <div className='static-content ck-content' style={{ filter: "grayscale(1) brightness(0)" }}>
                        
                        {/* <Image src={activity.thumbnail ? activity.thumbnail : placeholder} /> */}
                        <div dangerouslySetInnerHTML={{ __html: activity.content }} />
                      </div>
                    </section>
                }
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default ActivityDetail;
